import { SET_SESSION, SET_CONTRACT_DATA, SET_LOGGED_USER, SET_OBE_LOGGED_USER, SET_APP_CAT_COV_USER } from "../actions/types";
const initialState = {
  token: null,
  user:{},
  profileObject: {
    isRE:true,
    isSer:false,
    isSO:false,
    SingleLabel:'Product',
    SingleLabelWithSpace:'Product',
    PluralLabel:'Products',
    PluralLabelWithSpace:'Products'
  },
  img_required_flag: 1,
  isPaid: 0
};
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SESSION: {
      if (state.user?.loggedUser?.userType=='AUDITOR') {
        if (action.payload.supplierId) {
          action.payload.dupSupplierId = action.payload.supplierId;
        }
      }
      return {
        ...state,
        ...action.payload
      };
    }
    case SET_CONTRACT_DATA: {
      return {
        ...state,
        user: {
          ...action.payload
        }
      }
    }
    case SET_LOGGED_USER: {
      let newState = {...state};
      if(action.payload){
        newState.user.loggedUser = {
          ...action.payload
        }
      } else {
        delete newState.user.loggedUser;
      }
      return newState;
    }
    case SET_OBE_LOGGED_USER: {
      let newState = { ...state };
      newState.user.obeData = { ...action.payload }
      return newState;
    }
    case SET_APP_CAT_COV_USER: {
          let newState = {...state};
          newState.user.isUserApprovedForCatCoverage = action.payload;
          return newState;
        }
    default:
      return state;
  }
};
